import { PreRegistrationStepKey } from '@common/interfaces/pre-registration/pre-registration.interface';

/**
 * Static, translated investee-type options.
 * Values are sent as `company_info[investee_type]`; labels are POEditor keys.
 * `principal` → أصيل (Aseel), `agent` → وكيل (Wakeel).
 */
export const INVESTEE_TYPE_OPTIONS = [
  {
    value: 'principal',
    labelKey: 'pre_registration_investee_type_principal_label',
  },
  {
    value: 'agent',
    labelKey: 'pre_registration_investee_type_agent_label',
  },
] as const;

/**
 * Option value backing the single-checkbox NDA acceptance. The `accepted`
 * control holds a string[] (so it can use lib-checkbox-group); the payload
 * mapper derives the backend's boolean `agreed` from whether this value is set.
 */
export const NDA_ACCEPTED_VALUE = 'accepted';

/** Ordered step keys for the flow. */
export const PRE_REGISTRATION_STEP_KEYS: PreRegistrationStepKey[] = [
  'company',
  'cma',
  'contacts',
  'nda',
  'review',
];

/** Steps that call the backend to validate before advancing (review is client-only). */
export const VALIDATED_STEP_KEYS: PreRegistrationStepKey[] = [
  'company',
  'cma',
  'contacts',
  'nda',
];
